"use client";

import { Trans } from "@lingui/react/macro";
import { SparklesIcon, XIcon } from "lucide-react";
import { useState } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { isDemoMode } from "@/config";

export default function DemoAlert() {
  const [isOpen, setIsOpen] = useState(true);
  if (!isDemoMode) return null;
  if (!isOpen) return null;

  return (
    <Alert
      variant="default"
      className="fixed bottom-4 left-0 right-0 max-w-2xl mx-auto z-20"
    >
      <AlertTitle className="flex items-center">
        <SparklesIcon className="w-4 h-4 mr-1" />
        <Trans>This is a demo version.</Trans>
        <div className="ml-auto">
          <Button
            variant="ghost"
            size="icon"
            className="size-6"
            onClick={() => setIsOpen(false)}
          >
            <XIcon className="w-4 h-4" />
          </Button>
        </div>
      </AlertTitle>
      <AlertDescription>
        <Trans>
          Some features are limited and the data shown includes dummy data.
          Visit{" "}
          <a
            href="https://amethy.st"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500"
          >
            amethy.st
          </a>{" "}
          to get started with the full version.
        </Trans>
      </AlertDescription>
    </Alert>
  );
}
